export default {
    primary: { 
      900: '#0C3B2B',
    },
}
